import React from 'react'
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from 'react-share'

import { SITE_URL } from '../lib/constants'

type Props = {
  text: string
  path: string
  onClickTwitter?: (url: string) => void
  onClickFacebook?: (url: string) => void
}

export const Share = ({ text, path, onClickFacebook, onClickTwitter }: Props) => {
  const url = `${SITE_URL}${path}`

  return (
    <div className="flex justify-center list-none">
      <div
        className="mr-10"
        role="presentation"
        onClick={() => {
          onClickTwitter && onClickTwitter(url)
        }}
      >
        <TwitterShareButton
          url={`${url}`}
          title={text}
          className="focus:outline-none"
          hashtags={['unixtime']}
        >
          <TwitterIcon size={32} round={true} />
        </TwitterShareButton>
      </div>
      <div
        role="presentation"
        onClick={() => {
          onClickFacebook && onClickFacebook(url)
        }}
      >
        <FacebookShareButton
          url={`${url}`}
          className="focus:outline-none"
          hashtag="#unixtime"
        >
          <FacebookIcon size={32} round={true} />
        </FacebookShareButton>
      </div>
    </div>
  )
}
